import { useEffect } from "react";

export const EVENT_COMPLETE = "signing_complete";

const DocusignComplete = () => {
    useEffect(() => {
        window.parent.postMessage({ docusignEvent: EVENT_COMPLETE }, "*");
    }, []);

    return <p>Redirecting...</p>;
};

export default DocusignComplete;
